<div *ngIf='quickResponses' class='QuickResponsesListing p-5'>
  <div class='QuickResponsesListing-header d-flex flex-row mb-5'>
    <div
      class='QuickResponsesListing-header-title flex-grow-1 d-flex flex-row align-items-center'>
      <div class='flex-grow-1 d-flex flex-row'>
        <div class='flex-grow-1 d-flex flex-row'>
          <div class='Breadcrumbs'>
            <div class='Breadcrumbs-items'>
              <a [routerLink]="['/contents']"
              >
                <mat-icon class='Breadcrumbs-icon back'
                >keyboard_backspace
                </mat-icon
                >
              </a
              >
              <a [routerLink]="['/contents']" class='Breadcrumbs-item'
              >Quick Response</a
              >
            </div>
          </div>
          <fa-icon
            [icon]='iconQuestionCircle'
            [popoverAnimation]='true'
            [popoverDisabled]='false'
            [popoverOnHover]='true'
            [popoverPlacement]="'top-right'"
            [popover]='popoverText'
            class='title__icon ms-3'
            [size]="'1x'"></fa-icon>
        </div>
        <div class='flex-grow-0 text-end'>
          <app-button
            [Click]='newButtonProperties.onClick'
            [color]='newButtonProperties.color'
            [size]='newButtonProperties.size'
            [text]='newButtonProperties.text'
            class='pull-right'></app-button>
        </div>
      </div>
    </div>
  </div>
  <div class='QuickResponsesListing-items'>
    <div
      *ngFor='let response of quickResponses'
      class='QuickResponsesListing-items-item d-flex flex-row'>
      <div class='flex-grow-1 d-flex align-items-center'>
        <h4>{{ response.name }}</h4>
      </div>
      <div class='flex-grow-0'>
        <app-button
          [Click]='
            editButtonProperties.onClick.bind(this, response)
          '
          [color]='editButtonProperties.color'
          [size]='editButtonProperties.size'
          [style]="'filled'"
          [text]='editButtonProperties.text'></app-button>
      </div>
    </div>
  </div>
</div>
